export function upperCaseCompleteName( completeName ) {
    completeName = completeName.trim()
    
    var indexSpace
    var nameInUpperCase = ''
    var tempName

    for(var i = 0; i < completeName.length; i++) {
        if( completeName.includes(' ') ) {
            indexSpace = completeName.indexOf(' ', 1)
            tempName = completeName.substring(0, indexSpace + 1)
            let firstChar = tempName.charAt(0).toUpperCase()
            tempName = tempName.substring(1)
            nameInUpperCase = nameInUpperCase + firstChar + tempName
            i = 0
            completeName = completeName.substring(indexSpace + 1)

        } else {
            tempName = completeName.substring(0)
            let firstChar = tempName.charAt(0).toUpperCase()
            tempName = tempName.substring(1)
            nameInUpperCase = nameInUpperCase + firstChar + tempName

            return nameInUpperCase
        }
    }
}